import 'css-chunksrc/client/common/secondaryCriteriaForm/documentForm/styles.scss';export default {
  "documentForm": "_documentForm_1po20_1",
  "input": "_input_1po20_6",
  "listRoot": "_listRoot_1po20_17",
  "list": "_list_1po20_17",
  "directoryStructure": "_directoryStructure_1po20_33",
  "footer": "_footer_1po20_38",
  "loader": "_loader_1po20_46",
  "readOnly": "_readOnly_1po20_51",
  "disabled": "_disabled_1po20_57",
  "image": "_image_1po20_62",
  "flexible": "_flexible_1po20_67",
  "addIcon": "_addIcon_1po20_72"
};